import {
  GET_ALL_SUPPLIERS_REQUEST,
  GET_ALL_SUPPLIERS_SUCCESS,
  GET_ALL_SUPPLIERS_FAIL,
  ADD_SUPPLIER_REQUEST,
  ADD_SUPPLIER_SUCCESS,
  ADD_SUPPLIER_FAIL,
  CLEAR_PRODUCT_ERRORS,
  CLEAR_PRODUCT_MESSAGES,
} from "../constants/productConstants";

const initialSupplierState = {
  suppliers: [],
  supplierLoading: false,
  supplierError: null,
  supplierMessage: null,
};

export const supplierReducer = (state = initialSupplierState, action) => {
  switch (action.type) {
    case GET_ALL_SUPPLIERS_REQUEST:
    case ADD_SUPPLIER_REQUEST:
      return { ...state, supplierLoading: true, supplierError: null };

    case GET_ALL_SUPPLIERS_SUCCESS:
      return {
        ...state,
        supplierLoading: false,
        suppliers: Array.isArray(action.payload)
          ? action.payload
          : Array.isArray(action.payload?.suppliers)
            ? action.payload.suppliers
            : [],
        supplierMessage: action.payload?.message || "",
      };
    case ADD_SUPPLIER_SUCCESS:
      return {
        ...state,
        supplierLoading: false,
        suppliers: [...state.suppliers, action.payload],
        supplierMessage: "Supplier added successfully.",
      };
    case GET_ALL_SUPPLIERS_FAIL:
    case ADD_SUPPLIER_FAIL:
      return { ...state, supplierLoading: false, supplierError: action.payload };

    case CLEAR_PRODUCT_ERRORS:
      return { ...state, supplierError: null };
    case CLEAR_PRODUCT_MESSAGES:
      return { ...state, supplierMessage: null };

    default:
      return state;
  }
};
